import React from 'react';
import { useIntl } from 'react-intl';

import { TextInput } from '../../../../forms';
import { Paragraph } from '../../../../typography';

import ParticipantsAccessLevels from '../../groupAccessLevelSelect/ParticipantsAccessLevels';

const GroupDetails = ({ groupName, setGroupName, selectedUsers, participantLevels, setParticipantLevel }) => {
    const intl = useIntl();

    return (
        <div className="p-1 internal-group-details">
            <TextInput
                id="internal-group-name"
                name="groupName"
                value={groupName}
                placeholder={intl.formatMessage({ id: "Nome do grupo" })}
                onChange={e => setGroupName(e.target.value)}
            />
            <Paragraph className="mt-1 mb-50">
                {intl.formatMessage({ id: "Permissão de cada participante:" })}
            </Paragraph>
            <ParticipantsAccessLevels
                users={selectedUsers}
                participantLevels={participantLevels}
                setParticipantLevel={setParticipantLevel} />
        </div>
    );
};

export default React.memo(GroupDetails);
